import React, { Component } from "react";

import httpClient from '../../httpClient'
import { Button, Modal, ModalBody , Form, FormGroup, Input, Container, Label } from 'reactstrap';
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { logIn, signUp, signupPro } from "../../slices/modalSlice";
class LoginForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
          fields: {email: '', password: ''},
          errMsg:''
        };
      }

      onInputChange(evt) {
		this.setState({
			fields: {
				...this.state.fields,
				[evt.target.name]: evt.target.value
			}
		})
    }
    onFormSubmitLogin(evt) {
		evt.preventDefault()
		httpClient.logIn(this.state.fields).then(res => {
			if(res.success) {
        this.setState({ fields: { email: '', password: '' } })
        this.props.onLoginSuccess(res.token)
        this.toogleClose();		
			}
      else {
        this.setState({
          errMsg : res.data.message,
          errorType : res.data.errorType
        })
      }
		})
    }
 
  toogleClose = () =>this.props.dispatch(logIn())

  signUp = () => {
    this.props.dispatch(signUp())
  }
  signupPro = () =>{
    this
    .props
    .dispatch(signupPro())
  }
  openSignUpForm = () =>{
    this.toogleClose();
    this.signUp();
  }
  openSignUpProForm = () =>{
    this.toogleClose();
    this.signupPro()
  }
  
  render() {
    const {name, password } = this.state.fields
    const errMsg = this.state.errMsg
    const  errorType  = this.state. errorType 
    return (
        <div>
          <Container>
          <Modal isOpen={this.props.login} toggle={this.toogleClose} className={this.props.className}>
          <img src='/imgs/logo/Group_83.svg' alt='logo' className="logo-login-modal"  />
          <ModalBody>
            <Form className="form-login" onChange={this.onInputChange.bind(this)} onSubmit={this.onFormSubmitLogin.bind(this)} style={{marginBottom:"10px"}}>
            <div className="title-center">Connectez-vous</div>

              <FormGroup>
                <Input type="email" name="email" id="exampleEmail" placeholder="Adress e-mail" className="placeholder-center" value={name} style={{borderColor :errorType === "email" &&"red"}} ></Input>
                {errorType === "email"&&<Label className="connect-button submit-button mb-1" style={{fontSize:'13px',color:"red"}}>{errMsg}</Label>}
              </FormGroup>

              <FormGroup>
                  <Input type="password" className="placeholder-center" name="password" id="examplePassword" placeholder="Mot de passe" value={password} style={{borderColor :errorType === "password" &&"red"}}/>
                  {errorType === "password"&&<Label className="connect-button submit-button mb-0" style={{fontSize:'13px',color:"red"}}>{errMsg}</Label>}
              </FormGroup>

              <div className="connect-button">
              <Button className="submit-button" style={{backgroundColor:"#39296a",bottom:"107px",borderRadius:"11px"}}>Se Connecter</Button>
              </div>

              <p className="title-center">vous etes nouveau?</p>
              
              <div className="insc-button">
              <Button className="submit-button" style={{backgroundColor:"#00A706",borderRadius:"11px"}}
                   onClick={this.openSignUpForm}>{this.props.buttonLabel}  Inscriver vous</Button>              
              </div>

              <div className="connect-button">
               <div className="pro" onClick={this.openSignUpForm}>{this.props.buttonLabel}
               <span className="circle-Pro" type="button"><span className="text-Pro">PRO</span></span>
               </div>
              </div>

            </Form>
            </ModalBody>
          </Modal>
          </Container>
          </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    login: state.modal.login,
  }
}

//connect function INJECTS dispatch function as a prop!!
export default withRouter(connect(mapStateToProps)(LoginForm));